import "./loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <p>Processing...</p>
    </div>
  );
};

export default Loader;
